export default (name, key = null, classes = null) => {
  const reg = /{{(GLOBAL|OUTPUT|ASSET|CUSTOM):([^:^{^}]+)}}/g;
  const matches = reg.exec(name);
  if (matches) {
    let match = matches[0].replace('{{', '').replace('}}', '');
    let strToInsert = '';
    if (match.includes('GLOBAL:')) {
      strToInsert = name.replaceAll(matches[0], `<div class="bg-sky-500 text-white px-1.5 rounded-md w-max">${match.replace("GLOBAL:", "")}</div>`);
    } else if (match.includes('CUSTOM:')) {
      strToInsert = name.replaceAll(matches[0], `<div class="bg-green-500 text-white px-1.5 rounded-md w-max">${match.replace("CUSTOM:", "")}</div>`);
    } else if (match.includes('ASSET:')) {
      strToInsert = name.replaceAll(matches[0], `<div class="bg-yellow-500 text-white px-1.5 rounded-md w-max">${match.replace("ASSET:", "")}</div>`);
    } else if (match.includes('OUTPUT')) {
      strToInsert = name.replaceAll(matches[0], `<div class="bg-gray-500 text-white px-1.5 rounded-md w-max">${match.replace("OUTPUT:", "")}</div>`);
    }
    if (key) return <div dangerouslySetInnerHTML={{ __html: strToInsert }} key={key} className="flex"></div>
    return (
      <div dangerouslySetInnerHTML={{ __html: strToInsert }} key={key} className="flex"></div>
    );
  }
  return <div className={classes} key={key}>{name}</div>;
};